<template>
  <div class="create-item pt-4 pr-8 pb-8 pl-8">
    <ApolloMutation
      :mutation="query"
      :variables="variables"
      @done="onDone($event)"
      :update="updateCache"
    >
      <template v-slot="{ mutate, loading, error }">
        <div class="create-item__alert">
          <p class="alerts alerts-errors text-center" v-if="error">
            {{ print_error(error) }}
          </p>
        </div>

        <ValidationObserver v-slot="ob">
          <Form
            novalidate
            :valid="true"
            :loading="loading"
            @submit="ob.handleSubmit(mutate)"
          >
            <template>
              <ValidationProvider
                mode="passive"
                name="Name"
                rules="required"
                v-slot="v"
              >
                <FormGroup for="nameItem" :vee-errors="v.errors">
                  <InputVue
                    type="text"
                    :name="folderId"
                    :placeholder="labelInput"
                    v-model="nameItem"
                    :vee="v"
                  ></InputVue>
                </FormGroup>
              </ValidationProvider>
            </template>

            <FormSubmit
              slot="footer"
              class="p-4 btn-default"
              :disabled="loading"
              >{{ !loading ? 'Crea' : 'Creazione...' }}</FormSubmit
            >
          </Form>
        </ValidationObserver>
      </template>
    </ApolloMutation>
  </div>
</template>

<script>
/** Query */
import CREATE_PODCAST from '../graphql/CreatePodcast.gql'
import GET_FOLDER_DATA from '@/graphql/GetFolderData.gql'
import CREATE_FOLDER from '../graphql/CreateFolder.gql'

/** Components */
import Form from '@/components/Form.vue'
import FormGroup from '@/components/FormGroup.vue'
import FormSubmit from '@/components/FormSubmit.vue'
import InputVue from '@/components/fields/InputVue.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  components: {
    Form,
    FormGroup,
    FormSubmit,
    InputVue,
    ValidationObserver,
    ValidationProvider,
  },

  props: {
    itemType: {
      type: String,
      default: 'podcast',
    },

    folderId: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      nameItem: '',
      error: '',
    }
  },

  computed: {
    labelInput() {
      return (
        'Inserisci qui il nome ' +
        (this.itemType === 'podcast' ? 'del visual podcast' : 'della cartella')
      )
    },

    errorInput() {
      return (
        'Inserisci ' +
        (this.itemType === 'podcast'
          ? 'il titolo del visual podcast'
          : 'il nome della cartella')
      )
    },

    query() {
      return this.itemType === 'podcast' ? CREATE_PODCAST : CREATE_FOLDER
    },

    variables() {
      const variables = { name: this.nameItem, createdAt: Date.now() * 1000 }
      if (this.itemType === 'podcast') {
        variables.folderId = this.folderId
        variables.userId = this.$store.state.user.profile._id
      } else {
        variables.parentId = this.folderId
      }

      return variables
    },
  },

  methods: {
    onDone(data) {
      this.$emit('CreateItem', data)
    },

    print_error(err) {
      if (
        err.graphQLErrors &&
        err.graphQLErrors.length &&
        err.graphQLErrors[0].extensions &&
        err.graphQLErrors[0].extensions.code === 'instance not unique'
      ) {
        return "Questa cartella esiste già. Scegli un'altro nome"
      } else {
        console.dir(err)
        return 'Mutation server error'
      }
    },

    updateCache(store, res) {
      const query = {
        query: GET_FOLDER_DATA,
        variables: { id: this.folderId },
      }

      const data = store.readQuery(query)

      if (this.itemType === 'podcast') {
        data.findFolderByID.podcasts.data.push(res.data.createPodcast)
      } else {
        data.foldersByParent.data.push(res.data.createFolder)
      }

      store.writeQuery({ ...query, data })

      if (this.itemType === 'podcast') {
        this.$router.push({
          name: 'PodcastsSectionRoot',
          params: {
            id: res.data.createPodcast._id,
            tenant: this.$route.params.tenant,
          },
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
